export default __webpack_public_path__ + "static/media/home-business-services-img03.f84becce.jpg";